<template>
	<div class="d-flex align-items-center justify-content-between">
		<label v-if="label" id="hideinmobile" class="teams-label-font w-40"
			>{{ label }}<span v-if="mandatory" class="asterik">*</span></label
		>
		<div
			class="pointer w-100 position-relative"
			ref="customSelect"
			@keydown="handleKeyPress"
			:class="{
				'error-candash-custom-select height-38px p-0': showError,
				'candash-custom-select-2 p-0': !showError,
				'w-100': !label,
			}"
		>
			<div
				class="floating-label"
				:class="{
					'select-box w-100 h-100': showError,
				}"
			>
				<b-form-input
					type="text"
					@focus="openDropdown()"
					:placeholder="placeholder"
					class="w-100 h-100 serach-input text"
					:class="
						selectedOption != '' && selectedOption != null
							? 'text-capitalize'
							: ''
					"
					v-model.trim="selectedOption"
					@keyup="callInput($event)"
					@input="callInput($event)"
				></b-form-input>
				<label
					v-if="label"
					id="hideinlaptop"
					:class="{ active: isFocused || selectedOption }"
					>{{ label
					}}<span v-if="mandatory" class="asterik">&nbsp;*</span></label
				>
				<label
					v-else
					id="hideinlaptop"
					:class="{ active: isFocused || selectedOption }"
					>Mention your hobby<span v-if="mandatory" class="asterik"
						>&nbsp;*</span
					></label
				>
			</div>
			<ul
				ref="dropdownList"
				@scroll="onScroll"
				class="sws-select-options"
				v-if="showOptions && displayOptions.length > 0"
				:style="{
					'max-height':
						type === 'interpersonalSkill'
							? '104px'
							: id === 'onboardingSkill'
							? '140px'
							: '180px',
					bottom: id === 'hobbies' ? '25px' : '',
					top: id !== 'hobbies' ? '40px' : '',
				}"
			>
				<li
					v-if="
						(id === 'skillName' || id === 'onboardingSkill') &&
						skillLoading &&
						skillScrollDir === 'up'
					"
					class="skill-spinner-row"
					@click.stop
				>
					<b-spinner small variant="primary" label="Loading…"></b-spinner>
				</li>
				<li
					v-for="(option, index) in displayOptions"
					:key="index"
					class="search-select-option"
					:class="{ selected: isSelected(option.key) }"
					@click="
						selectOption(option.disabled == true ? this.selectedOption : option)
					"
					@keydown.enter="selectOption(option)"
					:tabindex="index === 0 ? 0 : -1"
					:id="option.key"
				>
					{{ option.label }}
				</li>
				<b-overlay
					v-if="type == 'organization' && this.total_count > 30"
					class="mt-4"
					:show="showLoader"
					rounded="sm"
				></b-overlay>
				<li
					v-if="
						(id === 'skillName' || id === 'onboardingSkill') &&
						skillLoading &&
						skillScrollDir === 'down'
					"
					class="skill-spinner-row"
					@click.stop
				>
					<b-spinner small variant="primary" label="Loading…"></b-spinner>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import {
	getSuggestionCollege,
	getSuggestionCompany,
	getSkillSuggestions,
} from "@/utils/apiFunctions";
export default {
	data() {
		return {
			timer: null,
			selectedOption: "",
			showOptions: false,
			showInput: false,
			isFocused: false,
			userInput: "",
			searchText: "",
			total_count: null,
			end_page: null,
			total_pages: null,
			showLoader: false,
			currentPage: 0,
			displayOptions: [],
			skillScrollDir: null,
			skillWindowStart: 0,
			skillWindowEnd: 0,
			skillNextPage: null,
			skillPrevPage: null,
			skillTotalPages: null,
			skillPageSize: 30,
			skillLoading: false,
			skillSearchText: "",
			skillSuggestionRequestId: 0,
			skillSearchTimer: null,
		};
	},
	props: {
		options: Array,
		validation: Object,
		type: String,
		isAdd: Boolean,
		placeholder: String,
		nationalityError: Boolean,
		mandatory: Boolean,
		type: String,
		id: String,
		showError: Boolean,
		label: String,
		vmodel: {
			validator: function () {
				return true;
			},
		},
		hideSuggestList: Boolean,
	},
	watch: {
		options(newValue, oldValue) {
			if (this.type == "organization") {
				this.displayOptions = newValue;
			} else if (newValue !== oldValue && this.showOptions) {
				this.fiterOptions();
			}
		},
		vmodel(newValue) {
			this.selectedOption = newValue;
			this.$emit("select-value", this.selectedOption);
		},
		hideSuggestList(val) {
			if (val) {
				this.showOptions = false;
				this.$forceUpdate();
				this.$nextTick(() => {
					this.$emit("reset-suggestList-cond", false);
				});
			}
		},
	},
	created() {
		if (this.id == "institute") {
			this.getCollegeSuggestion();
		} else if (this.id == "companyName") {
			this.getOrgSuggestion();
		} else {
			this.displayOptions = this.options;
		}
		if (this.vmodel) {
			this.selectedOption = this.vmodel;
		}
	},
	mounted() {
		document.addEventListener("click", this.closeDropdownOnClickOutside);
	},
	beforeDestroy() {
		document.removeEventListener("click", this.closeDropdownOnClickOutside);
	},
	methods: {
		onScroll(e) {
			const { target } = e;

			if (this.id === "skillName" || this.id === "onboardingSkill") {
				if (this.skillLoading) return;
				const THRESHOLD = 60;
				const atBottom =
					Math.ceil(target.scrollTop) + target.offsetHeight >=
					target.scrollHeight - THRESHOLD;
				const atTop = target.scrollTop <= THRESHOLD;

				if (atBottom) {
					this.skillScrollDir = "down";
					this.loadNextSkillPage();
				} else if (atTop) {
					this.skillScrollDir = "up";
					this.loadPrevSkillPage();
				}
				return;
			}
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				if (
					this.checkbetween(this.end_page, 0, this.total_count) &&
					!this.showLoader
				) {
					this.showLoader = true;
					this.currentPage++;
					if (this.id == "institute") {
						this.getCollegeSuggestion();
					} else if (this.id == "companyName") {
						this.getOrgSuggestion();
					}
				}
			}
		},
		async _fetchSkillPage(searchText, page) {
			try {
				const resp = await getSkillSuggestions({
					search: searchText || "",
					page,
				});
				if (resp?.status === 200 && resp.data?.data?.response) {
					const d = resp.data.data;
					return {
						items: d.response
							.map((item) => ({ key: item.value, label: item.text }))
							.filter((item) => item.label),
						next_page: d.next_page,
						prev_page: d.prev_page,
						total_pages: d.total_pages,
					};
				}
				return null;
			} catch {
				return null;
			}
		},
		async fetchSkillSuggestions(searchText) {
			if (this.skillLoading) return;
			this.skillSuggestionRequestId += 1;
			const requestId = this.skillSuggestionRequestId;
			this.skillLoading = true;
			try {
				const p0 = await this._fetchSkillPage(searchText, 0);
				if (requestId !== this.skillSuggestionRequestId) return;
				this.displayOptions = p0?.items ?? [];
				this.skillWindowStart = 0;
				this.skillWindowEnd = 0;
				this.skillPrevPage = p0?.prev_page ?? null;
				this.skillNextPage = p0?.next_page ?? null;
				this.skillTotalPages = p0?.total_pages ?? null;
				this.skillSearchText = searchText || "";
				this.showOptions = true;
			} finally {
				this.skillLoading = false;
				this.skillScrollDir = null;
			}
		},
		async loadNextSkillPage() {
			if (this.skillLoading) return;
			if (this.skillNextPage === null) return;
			this.skillLoading = true;
			try {
				const result = await this._fetchSkillPage(
					this.skillSearchText,
					this.skillWindowEnd + 1
				);
				if (!result) return;
				const combined = [...this.displayOptions, ...result.items];
				const maxItems = this.skillPageSize * 3;
				if (combined.length > maxItems) {
					this.displayOptions = combined.slice(combined.length - maxItems);
					this.skillWindowStart += 1;
				} else {
					this.displayOptions = combined;
				}
				this.skillWindowEnd += 1;
				this.skillNextPage = result.next_page;
				this.skillPrevPage =
					this.skillWindowStart > 0 ? this.skillWindowStart - 1 : null;
				this.$nextTick(() => {
					const ul = this.$refs.dropdownList;
					if (ul && ul.scrollHeight > 0) ul.scrollTop = ul.scrollHeight * 0.5;
				});
			} finally {
				this.skillLoading = false;
				this.skillScrollDir = null;
			}
		},
		async loadPrevSkillPage() {
			if (this.skillLoading) return;
			if (this.skillWindowStart === 0) return;
			this.skillLoading = true;
			try {
				const result = await this._fetchSkillPage(
					this.skillSearchText,
					this.skillWindowStart - 1
				);
				if (!result) return;
				const combined = [...result.items, ...this.displayOptions];
				const maxItems = this.skillPageSize * 3;
				if (combined.length > maxItems) {
					this.displayOptions = combined.slice(0, maxItems);
					this.skillWindowEnd -= 1;
				} else {
					this.displayOptions = combined;
				}
				this.skillWindowStart -= 1;
				this.skillPrevPage = result.prev_page;
				this.skillNextPage = result.next_page;
				this.$nextTick(() => {
					const ul = this.$refs.dropdownList;
					if (ul && ul.scrollHeight > 0) ul.scrollTop = ul.scrollHeight * 0.5;
				});
			} finally {
				this.skillLoading = false;
				this.skillScrollDir = null;
			}
		},
		async getOrgSuggestion() {
			try {
				let payload = {
					companyName: this.selectedOption,
					page: this.currentPage,
				};
				const resp = await getSuggestionCompany(payload);
				const responseData = resp.data.data.response;
				if (resp.status == 200) {
					const mapItem = (item) => ({
						key: item.value?.value ?? item.value,
						label: item.text?.text ?? item.text,
					});
					if (this.currentPage == 0) {
						this.displayOptions = responseData.map(mapItem);
					} else {
						this.displayOptions = [
							...this.displayOptions,
							...responseData.map(mapItem),
						];
					}
					this.end_page = resp.data.data.end_page;
					this.total_count = resp.data.data.total_count;
					this.total_pages = resp.data.data.total_pages;
					this.showLoader = false;
					// this.end_page === this.total_count ? (this.showLoader = false) : "";
				} else {
					console.log("Api error");
				}
			} catch (error) {
				console.log(error);
			}
		},
		async getCollegeSuggestion() {
			try {
				let payload = {
					institute: this.selectedOption,
					page: this.currentPage,
				};

				const resp = await getSuggestionCollege(payload);

				if (resp.status === 200) {
					const responseData = resp.data.data.response;
					const isFirstPage = this.currentPage === 0;

					// If it's the first page, reset displayOptions, otherwise append new results
					const mapItem = (item) => ({
						key: item.value?.value ?? item.value,
						label: item.text?.text ?? item.text,
					});
					if (isFirstPage) {
						this.displayOptions = responseData.map(mapItem);
					} else {
						this.displayOptions = [
							...this.displayOptions,
							...responseData.map(mapItem),
						];
					}

					// Update pagination data
					this.end_page = resp.data.data.end_page;
					this.total_count = resp.data.data.total_count;
					this.total_pages = resp.data.data.total_pages;

					// Hide loader when data is loaded
					this.showLoader = false;

					// Optionally, handle case where end_page matches total_pages to stop loading
					// if (this.end_page === this.total_pages) {
					//     this.showLoader = false;
					// }
				} else {
					console.error("API error: ", resp.status);
					// Optionally, you could display an alert or a UI message here
					this.showLoader = false; // Hide loader on error
				}
			} catch (error) {
				console.error("Error fetching college suggestions: ", error);
				this.showLoader = false; // Ensure loader is hidden on error
			}
		},
		checkbetween(x, min, max) {
			// Return `true` if `x` is between `min` and `max`, otherwise `false`.
			return x > min && x < max;
		},
		callInput(e) {
			// Don't react to navigation/action keys — handleKeyPress owns those
			if (
				e &&
				e.type === "keyup" &&
				["ArrowDown", "ArrowUp", "Enter"].includes(e.key)
			) {
				return;
			}
			if (this.type == "organization") {
				clearTimeout(this.timer);

				this.timer = setTimeout(() => {
					this.$emit("select-value", this.selectedOption);
					this.$emit("reset-current-page");
				}, 500);
			} else {
				this.$emit("select-value", this.selectedOption);
			}
			if (this.id == "institute") {
				this.getCollegeSuggestion();
			} else if (this.id == "companyName") {
				this.getOrgSuggestion();
			} else if (this.id === "skillName" || this.id === "onboardingSkill") {
				this.showOptions = true;
				if (this.skillSearchTimer) clearTimeout(this.skillSearchTimer);
				this.skillSearchTimer = setTimeout(() => {
					this.fetchSkillSuggestions(this.selectedOption?.trim() || "");
				}, 350);
			} else {
				this.fiterOptions();
			}
			if (this.type == "nationality") {
				this.$emit("type-nationality");
			}
		},
		openDropdown() {
			this.$emit("focus");
			if (this.id == "institue") {
				this.getCollegeSuggestion();
			} else if (this.id == "companyName") {
				this.getOrgSuggestion();
			} else if (this.id === "skillName" || this.id === "onboardingSkill") {
				this.fetchSkillSuggestions(this.selectedOption?.trim() || "");
			} else {
				this.displayOptions = this.options || [];
			}
			this.showOptions = true;
			this.$nextTick(() => {
				let sectionElement = document.getElementById(this.selectedOption);
				if (sectionElement) {
					sectionElement.scrollIntoView({
						behavior: "instant",
						block: "center",
					});
				}
			});
		},
		fiterOptions() {
			// Filter options that start with the selected input
			const startsWithSelected = this.options.filter((option) =>
				option.label.toLowerCase().startsWith(this.selectedOption.toLowerCase())
			);

			// Filter options that contain the selected input
			const containsSelected = this.options.filter(
				(option) =>
					!option.label
						.toLowerCase()
						.startsWith(this.selectedOption.toLowerCase()) &&
					option.label.toLowerCase().includes(this.selectedOption.toLowerCase())
			);

			// Concatenate startsWithSelected options followed by containsSelected options
			this.displayOptions = [...startsWithSelected, ...containsSelected];
			this.showOptions = true;
		},
		toggleOptions() {
			this.showOptions = !this.showOptions;
		},
		selectOption(option) {
			this.selectedOption = option.label;
			if (!this.isAdd) {
				this.showOptions = false;
			}
			this.$emit("select-value", this.selectedOption);
			if (this.isAdd) {
				this.$emit("add-value");
				this.displayOptions = this.displayOptions.filter(
					(option) =>
						!option.label
							.toLowerCase()
							.includes(this.selectedOption.toLowerCase())
				);
				this.selectedOption = "";
			}
			if (this.type == "nationality") {
				this.$emit("type-nationality");
			}
		},
		isSelected(option) {
			return option === this.selectedOption;
		},
		handleKeyPress(event) {
			const options = this.displayOptions;
			const selectedIndex = options.findIndex(
				(option) => option.key === this.selectedOption
			);
			const dropdown = document.querySelector(".sws-select-options");

			if (event.key === "ArrowDown") {
				if (!this.showOptions) {
					this.showOptions = true;
					this.selectedOption = options.length > 0 ? options[0].key : "";
				} else if (selectedIndex < options.length - 1) {
					this.selectedOption = options[selectedIndex + 1].key;
					// Scroll the dropdown if necessary
					const selectedOptionElement = document.getElementById(
						this.selectedOption
					);
					if (selectedOptionElement) {
						selectedOptionElement.scrollIntoView({
							behavior: "smooth",
							block: "nearest",
						});
					}
				}
				event.preventDefault(); // Prevent default behavior
			} else if (event.key === "ArrowUp") {
				if (!this.showOptions) {
					this.showOptions = true;
					this.selectedOption =
						options.length > 0 ? options[options.length - 1].key : "";
				} else if (selectedIndex > 0) {
					this.selectedOption = options[selectedIndex - 1].key;
					// Scroll the dropdown if necessary
					const selectedOptionElement = document.getElementById(
						this.selectedOption
					);
					if (selectedOptionElement) {
						selectedOptionElement.scrollIntoView({
							behavior: "smooth",
							block: "nearest",
						});
					}
				}
				event.preventDefault(); // Prevent default behavior
			} else if (event.key === "Enter") {
				// this.$emit("select-value", this.selectedOption);
				// Skill fields: select the highlighted option (same as click) and close
				if (
					(this.id === "skillName" || this.id === "onboardingSkill") &&
					this.showOptions &&
					this.displayOptions.length > 0
				) {
					const highlighted =
						this.displayOptions.find(
							(opt) => opt.key === this.selectedOption
						) || this.displayOptions[0];
					if (highlighted) this.selectOption(highlighted);
					return;
				}

				if (this.type == "nationality") {
					this.$emit("type-nationality");
				}
				this.$emit("add-value");

				if (this.type == "hobby") {
					this.displayOptions = this.options.filter(
						(item) => item.key != this.selectedOption
					);
					this.selectedOption = "";
				} else {
					this.displayOptions = this.options;
					this.toggleOptions();
				}
			}
		},

		closeDropdownOnClickOutside(event) {
			if (!this.$refs.customSelect.contains(event.target)) {
				this.showOptions = false;
			}
		},
		onInput(event) {
			this.searchText = event.target.key;
		},
	},
};
</script>

<style>
.serach-input {
	border: none;
	border-radius: 8px;
	padding-left: 10px;
	font-size: var(--size-14) !important;
	font-weight: 500 !important;
	color: var(--cv-darkgrey) !important;
	font-family: "Montserrat", sans-serif;
}
.text-capitalize {
	text-transform: capitalize;
}
.serach-input:focus-visible {
	outline: none;
}

.serach-input:focus {
	box-shadow: none;
}
.search-select-option {
	padding: 4px 10px;
	cursor: pointer;
	color: #333 !important;
	font-size: 13px !important;
	font-weight: 500 !important;
}

.search-select-options .search-select-option:first-child {
	/* Your styles for the first <li> element */
	color: #8c8c8c !important;
	font-size: 12px !important;
	font-weight: 400;
	font-family: "montserrat", sans-serif;
	background-color: transparent;
}

.search-select-option:hover {
	background-color: #e8eff4;
}

.search-select-option.selected {
	background-color: #c8d9e5;
}

.candash-custom-select-2 {
	height: 38px !important;
	border-radius: 8px !important;
	border: 1px solid var(--gray-300, #d0d5dd) !important;
	background: var(--base-white, #fff) !important;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
	color: #a3a0a0 !important;
	font-size: 12px !important;
	font-weight: 400 !important;
	display: flex;
	align-items: center;
	padding-left: 10px;
}

.height-38px {
	height: 38px !important;
}

.sws-select-options {
	position: absolute;
	overflow: auto;
	border: 1px solid #2988e638;
	background-color: #f9f9f9;
	z-index: 3;
	border-radius: 4px;
	width: 100%;
	box-shadow: 0px 8px 15px 0px #00000066;
	list-style-type: none;
	padding-left: 0px;
}
.skill-spinner-row {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 10px;
	cursor: default;
	background-color: #f9f9f9;
}

.skill-spinner-row:hover {
	background-color: #f9f9f9;
}

@media only screen and (max-width: 1028px) {
	.sws-select-options::-webkit-scrollbar {
		width: 5px !important;
		height: 5px !important;
	}
	.serach-input::placeholder {
		color: #ffffff;
	}
}

/* Your styles here */
</style>
